// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1I9yK","col":"styles_col__1zAm0","actions":"styles_actions__2LRH3","conflict":"styles_conflict__17ytO"};